import { CustomAppLayout } from '../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useRef, useState } from 'react';
import { useRouter } from '../../router';
//import { useStore } from '../store';
import { useGlobalState } from '../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../context/useStoreAdmin';

import { Button, Checkbox, Form, FormField, Input, SpaceBetween } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import Favorites from '../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../hooks/fetchWithWatch';
import { ItemBelt } from '../../../../resources/types';
import { addNotification, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading } from '../../../commons/functions';


export const ConfigBeltsEditPage = () => {
  //const storeAdmin = useStoreAdmin();
  const [belt, setBelt] = useState<ItemBelt | null>(null);

  const { navigate } = useRouter();
  const { menu, idAirport } = useGlobalState();

  const isFirstRender = useRef(true);
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    const timer = setTimeout(() => {
      navigate('config/belts.edit?id=0')
    }, 500);
    return () => clearTimeout(timer);
  }, [idAirport]);
  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.split("?")[1]);
      const id = params.get("id");
      if (id)
        handleGetBelt(parseInt(id));
      else {
        setBelt(null);
      }
      //handleGetEmail(id ? parseInt(id) : 0);
      //else
      //setMailTemplate(undefined);
    };

    window.addEventListener("hashchange", handleHashChange);
    // also trigger once on mount
    handleHashChange();

    return () => window.removeEventListener("hashchange", handleHashChange);
  }, []);
  useEffect(() => {

  }, []);


  const handleUpdateBelt = async () => { // Make the function async

    try {
      setLoading(true)
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'JWT': getCookie("JWT"),
          'x-routing': '/private/config/belts/update',
        },
        body: JSON.stringify(belt),

      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const dataWeb = await response.json();
      if (dataWeb.code == 0) {
        addNotification(dataWeb.status, 'success', setData);
        window.location.hash = "#config/belts";
      } else {
        addNotification(dataWeb.status, 'error', setData);
      }
    } catch (error: any) {
      addNotification(`Error al contactar el servidor: ${error.message}`, 'error', setData);
    } finally {
      setLoading(false)
    }
  };
  const handleGetBelt = async (id: number) => { // Make the function async

    try {
      setLoading(true)
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'JWT': getCookie("JWT"),
          'x-routing': '/private/config/belts/get',
        },
        body: JSON.stringify({ idBelt: id }),

      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const dataWeb = await response.json();
      if (dataWeb.code == 0) {
        if (dataWeb.belt === null) {
          navigate('config/belts');
          return;
        }
        setBelt(dataWeb.belt);
      } else {
        addNotification(dataWeb.status, 'error', setData);
      }
    } catch (error: any) {
      addNotification(`Error al contactar el servidor: ${error.message}`, 'error', setData);
    } finally {
      setLoading(false)
    }
  };

  return (
    <CustomAppLayout
      toolsHide={true}
      breadcrumbs={
        <BreadcrumbGroup
          items={buildBreadcrumbItems(menu)}
          expandAriaLabel="Show path"
          ariaLabel="Breadcrumbs"
        />
      }
      content={
        <SpaceBetween size="s">
          <Header variant="h1" actions={<Favorites />}>{`Cintas de equipaje ${belt ? belt.belt : ''}`}</Header>
          {belt && (
            <Form actions={
              <SpaceBetween size="m" direction='horizontal'>
                <Button variant="link" onClick={() => { window.location.hash = "#config/belts"; }}>Cancelar</Button>
                <Button variant="primary" onClick={() => {
                  console.log(belt)
                  handleUpdateBelt();
                }}>Actualizar</Button>
              </SpaceBetween>}>

              <SpaceBetween size="m" direction='vertical'>
                <div style={{ width: 200 }}>
                  <FormField label="Número de cinta">
                    <Input value={belt.belt} onChange={e => {
                      setBelt({ ...belt!, belt: e.detail.value });
                    }} />
                  </FormField>
                </div>
                <Checkbox checked={belt.isActiveBelt === 1} onChange={e => {
                  setBelt({ ...belt!, isActiveBelt: e.detail.checked ? 1 : 0 });
                }}>Activo</Checkbox>
                <div style={{ width: 200 }}>
                  <FormField label="TAG RMS" constraintText="ID utilizado en el sistema RMS">
                    <Input value={belt.AODBTAG} onChange={e => {
                      setBelt({ ...belt!, AODBTAG: e.detail.value });
                    }} />
                  </FormField>
                </div>
              </SpaceBetween>
            </Form>
          )}
        </SpaceBetween>
      }
    />
  )
};
